import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HTML2TXTPipe } from './../../shared/pipe/common.pipe';
import { BehaviorSubject } from 'rxjs';
import * as CryptoJS from 'crypto-js';


@Injectable({
    providedIn: 'root'
})
export class SharedService {

    public rootData: any = {};
    public env: any = environment;
    public host = (globalThis.document.URL.includes(environment.innovate.FEMaskedURL)) ? environment.innovate.maskedUrl : environment.innovate.url;
    public newBEHost = (globalThis.document.URL.includes(environment.innovate.FEMaskedURL)) ? environment.innovate.maskedUrl : environment.innovate.newBEHost;
    public base_url: any;
    public baseURLV2:any;
    private readonly updateRootDataQuestionsSource = new BehaviorSubject(null);
    public updateRootDataQuestionsSubscribed = this.updateRootDataQuestionsSource.asObservable();
    private readonly multiPunchCheckboxSource = new BehaviorSubject(null);
    public multiPunchCheckboxSubscribed = this.multiPunchCheckboxSource.asObservable();

    constructor(private readonly http: HttpClient, public HTML2TXT1: HTML2TXTPipe) {
        this.base_url = this.host + '/api/' + environment.innovate.version;
        this.baseURLV2 = this.newBEHost + '/api/' + environment.innovate.version;
    }

    // public sendRecaptchaToServer(obj: any) {
    //     return this.http.post(this.baseURLV2 + '/userResponseValidate/verifyRecaptcha/', obj);
    // }

    public checkFormDtlsByUSPSService(addrsDetails: any, token: any) {
        const obj: any = {};
        obj.addrsDetails = addrsDetails;
        obj.token = token;
        return this.http.post(this.baseURLV2 + '/userResponseValidate/verifyPIIAddrsDetails/', this.commonEncryptionMethod(obj));
    }

    public clearLocalStorage() {
        console.info('Clearing local storage');
        localStorage.clear();
    }

    public validateMobNum(mobDetails: any) {
        const obj: any = {};
        obj.mobDetails = mobDetails;
        return this.http.post(this.baseURLV2 + '/userResponseValidate/verifyMobNum/', this.commonEncryptionMethod(obj));
    }

    public getTargettingQuestions(condition: any, limit: number, sort: any) {
        const data: any = {};
        data.condition = condition;
        data.sort = sort;
        data.limit = limit;
        return this.http.post(this.base_url + '/getQuestions/', data);
    }

    public preSurveyTerminationInQA(body: any) {
        return this.http.post(this.baseURLV2 + '/respondent/preSurveyTerminationInQA/', body);
    }

    public updateAllTargetData(body: any) {
        return this.http.post(this.baseURLV2 + '/respondent/updateAllTargetData', this.commonEncryptionMethod(body));
    }

    public registerRespondent(body: any) {
        return this.http.post(this.base_url + '/dyRegisterRespondent/', body);
    }

    public getSupplierUrl(query_strings: string, body: any) {
        if(this.env.innovate.triggerNewSupplierURL){
            return this.http.post(`${this.baseURLV2}/survey/getSupplierUrl/?`+query_strings, this.commonEncryptionMethod(body),{
                observe: "response"
            });
        }else{
            return this.http.post(this.host + '/getSupplierUrl/?' + query_strings, this.commonEncryptionMethod(body), {
                observe: "response"
            });
        }
    }

    public getSupplierTestUrl(query_strings: string) {
        let host = this.host;

        if(this.env.innovate.triggerNewSupplierURL){
            host = this.baseURLV2 + '/survey';
        }
        return this.http.get(host + '/getSupplierTestUrl/?' + query_strings);
    }

    public getDecryptedSurvNum(survNum: any) {
        return this.http.get(this.base_url + '/get_decrypted_suvrnum/' + survNum);
    }

    public getDecryptedUID(uid: any) {
        return this.http.get(this.base_url + '/get_decrypted_uid/' + uid);
    }

    public getSurveyTargetDetails(payload: any) {
        return this.http.post(`${this.baseURLV2}/survey/getSurveyTargetDetails`, this.commonEncryptionMethod(payload));

    }

    public getGrpTrgtQuestions(grp_id: any, isp: any, oe: any, supCode: any) {
        return this.http.get(this.base_url + '/getGrpTrgtQuestions/' + grp_id + '/' + isp + '/' + supCode + (oe ? '/' + oe : ''));
    }

    public getTargetStats(grp_id: any) {
        return this.http.get(this.base_url + '/getTargetStats/' + grp_id);
    }

    public getGrpDetails(grp_id: any, oe: any) {
        return this.http.get(this.base_url + '/getGroupDetails/' + grp_id + (oe ? '/' + oe : ''));
    }

    public getJobDetails(job_id: any) {
        return this.http.get(this.base_url + '/getJobDetails/' + job_id);
    }

    public getTransaction(uid: string) {
        return this.http.get(this.baseURLV2 + '/respondent/getTransactionDetails/' + uid);
    }

    public getDigitalFingerprinting(cmp_id: any) {
        return this.http.get(this.baseURLV2 + '/survey/getDigitalFingerprinting/' + cmp_id);
    }

    public getPanelistAnswers(query_strings: string) {
        return this.http.get(this.base_url + '/getPanelistAnswers/?' + query_strings);
    }

    public getRAIDobAgeDetails(grp_id: any, age: any, zip: any) {
        return this.http.get(this.baseURLV2 + '/survey/getRaiDobZip/' + grp_id + '/' + age + '/' + zip);
    }

    public getSurveyFlowDetails() {
        return this.http.get(this.base_url + '/getSurveyFlowDetails');
    }

    public updateAllPanelistProfile(body: any) {
        return this.http.post(this.baseURLV2 + '/respondent/updateAllPanelistProfile/', body);
    }

    public syncProfilingQusWithPc(grp_id: any, PID: any, supCode: any, uid: any) {
        const obj: any = {
            grp_id,
            PID,
            supCode,
            uid,
        };

        return this.http.post(this.baseURLV2 + '/respondent/syncProfilingQusWithPc/', this.commonEncryptionMethod(obj));
    }

    public deleteKeyLocalStorageSavedAnswers(keyForSaving: any) {
        const localStorageSavedAnswers: any = this.getLocalStorage('localStorageSavedAnswers');

        localStorageSavedAnswers.forEach((data: any, index: number) => {
            if (data[keyForSaving]) {
                delete localStorageSavedAnswers[index][keyForSaving];
                this.setLocalStorage('localStorageSavedAnswers', localStorageSavedAnswers);
            }
        });
    }

    /**
     * Allowed question keys for resume localStorage / Let's Go grp_data.
     * Only current group targeting (+ geo keys) so obsolete answers after targeting edits do not conflict.
     */
    public getAllowedResumeChoiceKeys(grpTrgtQuestions: any[] = [], geoQuestionsKeyDetails: any[] = []): Set<string> {
        const allowed = new Set<string>();
        (grpTrgtQuestions || []).forEach((que: any) => {
            const key = que?.q_key || que?.questionKey;
            if (key) {
                allowed.add(String(key).toUpperCase());
            }
        });
        (geoQuestionsKeyDetails || []).forEach((key: any) => {
            if (key) {
                allowed.add(String(key).toUpperCase());
            }
        });
        // Keep form blobs used by final / pii / sms flows
        allowed.add('PIIFORMDETAILS');
        allowed.add('SMSFORMDETAILS');
        return allowed;
    }

    /**
     * Convert panelist_user_choices.choices (+ optional pii/sms) into localStorageSavedAnswers shape:
     * [{ [keyForSaving]: [ { AGE: {...} }, { piiFormDetails: {...} } ] }]
     * Only keys still present in current targeting are kept.
     */
    public buildResumeLocalStorageChoices(
        savedChoices: any[] = [],
        keyForSaving: string,
        allowedKeys: Set<string>,
        extras: { piiFormDetails?: any; smsFormDetails?: any } = {}
    ): any[] {
        const choiceEntries: any[] = [];

        (savedChoices || []).forEach((choice: any) => {
            if (!choice) {
                return;
            }
            // Backend may send either flat choice objects or already-keyed localStorage entries
            if (choice.question_key || choice.questionKey) {
                const qKey = String(choice.question_key || choice.questionKey).toUpperCase();
                if (!allowedKeys.has(qKey)) {
                    return;
                }
                const normalized = {
                    ...choice,
                    question_key: choice.question_key || choice.questionKey
                };
                choiceEntries.push({ [normalized.question_key]: normalized });
                return;
            }

            const entryKey = Object.keys(choice)[0];
            if (!entryKey || !allowedKeys.has(entryKey.toUpperCase())) {
                return;
            }
            choiceEntries.push(choice);
        });

        if (extras.piiFormDetails && Object.keys(extras.piiFormDetails).length) {
            choiceEntries.push({ piiFormDetails: extras.piiFormDetails });
        }
        if (extras.smsFormDetails && Object.keys(extras.smsFormDetails).length) {
            choiceEntries.push({ smsFormDetails: extras.smsFormDetails });
        }

        if (!choiceEntries.length) {
            return [];
        }
        return [{ [keyForSaving]: choiceEntries }];
    }

    /**
     * Hydrate localStorage for phn2Web / cross-browser PSDNC resume.
     * Merges resume choices under keyForSaving; does not wipe answers already typed on this device.
     */
    public hydrateLocalStorageFromResume(
        savedChoices: any[] = [],
        keyForSaving: string,
        grpTrgtQuestions: any[] = [],
        geoQuestionsKeyDetails: any[] = [],
        extras: { piiFormDetails?: any; smsFormDetails?: any } = {}
    ): boolean {
        if (!keyForSaving || !savedChoices?.length) {
            return false;
        }

        const allowedKeys = this.getAllowedResumeChoiceKeys(grpTrgtQuestions, geoQuestionsKeyDetails);
        const resumeStorage = this.buildResumeLocalStorageChoices(savedChoices, keyForSaving, allowedKeys, extras);
        if (!resumeStorage.length) {
            return false;
        }

        const existing: any[] = this.getLocalStorage('localStorageSavedAnswers') || [];
        const resumeEntries = resumeStorage[0][keyForSaving] || [];
        let targetBucket = existing.find((item: any) => item?.[keyForSaving]);

        if (!targetBucket) {
            if (!existing.length) {
                this.setLocalStorage('localStorageSavedAnswers', resumeStorage);
            } else {
                existing[0][keyForSaving] = resumeEntries;
                this.setLocalStorage('localStorageSavedAnswers', existing);
            }
            return true;
        }

        // Merge: keep local answers for a key; fill missing keys from resume (backend / other device)
        const merged = [...targetBucket[keyForSaving]];
        resumeEntries.forEach((resumeEntry: any) => {
            const resumeKey = Object.keys(resumeEntry)[0];
            const idx = merged.findIndex((localEntry: any) => Object.keys(localEntry)[0] === resumeKey);
            if (idx === -1) {
                merged.push(resumeEntry);
            }
        });
        targetBucket[keyForSaving] = merged;
        this.setLocalStorage('localStorageSavedAnswers', existing);
        return true;
    }

    /**
     * Drop localStorage answers that are no longer part of current targeting (targeting changed mid-resume).
     */
    public pruneLocalStorageToCurrentTargeting(
        keyForSaving: string,
        grpTrgtQuestions: any[] = [],
        geoQuestionsKeyDetails: any[] = []
    ): void {
        if (!keyForSaving) {
            return;
        }
        const existing: any[] = this.getLocalStorage('localStorageSavedAnswers') || [];
        if (!existing.length) {
            return;
        }
        const allowedKeys = this.getAllowedResumeChoiceKeys(grpTrgtQuestions, geoQuestionsKeyDetails);
        let changed = false;

        existing.forEach((bucket: any) => {
            if (!bucket?.[keyForSaving] || !Array.isArray(bucket[keyForSaving])) {
                return;
            }
            const filtered = bucket[keyForSaving].filter((entry: any) => {
                const key = Object.keys(entry)[0];
                return key && allowedKeys.has(key.toUpperCase());
            });
            if (filtered.length !== bucket[keyForSaving].length) {
                changed = true;
                bucket[keyForSaving] = filtered;
            }
        });

        if (changed) {
            this.setLocalStorage('localStorageSavedAnswers', existing);
        }
    }

    /**
     * Filter Let's Go grp_data to current targeting keys only.
     */
    public filterGrpDataForCurrentTargeting(
        grpData: any[] = [],
        grpTrgtQuestions: any[] = [],
        geoQuestionsKeyDetails: any[] = []
    ): any[] {
        if (!grpData?.length) {
            return [];
        }
        const allowedKeys = this.getAllowedResumeChoiceKeys(grpTrgtQuestions, geoQuestionsKeyDetails);
        return grpData.filter((entry: any) => {
            const key = Object.keys(entry || {})[0];
            return key && allowedKeys.has(key.toUpperCase());
        });
    }


    public serialize(obj: any) {
        const str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    public getNextState(questions: any, currentState: any, orgTerm: any, reason?: any) {
        //here we will check next state according to saved data in group_targets
        //if any targetting not saved than it will traverse to final state directly
        let nextState = 'final';
        if (this.rootData.isAgeOfChildAdded
            && currentState === this.env.innovate.ageOfChildrenQueKey) {
            const queData: any = [];
            questions.forEach((que: any) => {
                if (this.env.innovate.babyCenterChildQueAdded.includes(que.questionKey)) {
                    queData.push(que);
                }
            })
            currentState = queData.at(-1)!.questionKey;
        }

        if(questions?.length)
        {
            questions.forEach((element: any, index: number) => {
                if ((this.HTML2TXT1.transform((element.questionKey.toString()).toLowerCase()) === (this.HTML2TXT1.transform(currentState.toLowerCase()))) || (currentState === "pii")) {
                    let nextCounter = index + 1;
                    if (questions[nextCounter]) {
                        nextState = this.HTML2TXT1.transform(questions[nextCounter].questionKey.toLowerCase());
                    }
                }
            });
        }

        let questionKeys = questions.map((que: any) => { return que.questionKey }); // question key of group targetting;

        if (currentState === 'pii' && !questionKeys.includes('SMS_VERIFICATION') && !this.rootData.Test && !this.rootData.smsVerified) {
            nextState = 'final'
        }
        if (reason === 'PII_OPT') {
            nextState = 'closed';
        }

        if (nextState === 'final' 
            && this.rootData.surveyFlowLogic 
            && orgTerm) {
            nextState = 'closed';
        }
        const isTerm = this.commonPCCondition();
        if (isTerm && this.rootData.originalTerm) {
            nextState = 'closed';
        }
        return nextState;
    }

    checkTermination(question_id: any, question_type: any, get_targetting_questions: any, answer: any, countyCode: any, trgAgeAns: any) {
        let isTerminate = false;
        let singleQuestion: any = {};
        let ageQuesOption: any = [];
        let isAGEExist = false;//Checking if isAGEExist on not in targeting

        get_targetting_questions.forEach((single_question: any) => {
            if (single_question.q_id
                && single_question.q_id.toString() === question_id.toString()) {
                singleQuestion = single_question;
            }
            //We need to get Age question options to validate DOB  red herring question if q_key = DOB(Red Herring question)
            if (single_question.q_key == "AGE" && question_id == this.env.innovate.dobRedHerringQId) {
                ageQuesOption = single_question.opts;
                isAGEExist = true;
            }
        });

        if (question_type) {
            let questionKey = singleQuestion.q_key; // question key
            let questionOptions = singleQuestion.opts || []; // question answers
            let optionIds = [];
            let optionTxt = [];
            let isFallBetweenAge;
            if (singleQuestion.q_id == this.env.innovate.dobRedHerringQId) { questionOptions = ageQuesOption; }
            for (let i = 0, len = questionOptions.length; i < len; i++) {
                if (questionOptions[i]['opt_id']) {
                    optionIds.push(questionOptions[i]['opt_id'].toString());
                    if ((this.env.innovate.cntShortCode[countyCode]) && (questionKey == "DMA_CODE" || questionKey == "DMA_NAME" || questionKey == "STATE" || questionKey == "REGION")) {
                        //Here, neglect paranthesis text for eg, WASHINGTON, DC (HAGRSTWN) converts into WASHINGTON, DC
                        let opt_txt = (questionOptions[i]['opt_txt'].includes('(')) ? questionOptions[i]['opt_txt'].split('(')[0].trim() : questionOptions[i]['opt_txt'];
                        optionTxt.push(opt_txt);
                    }
                }
            }
            switch (question_type.toString()) {
                case 'Numeric Open Ended':
                    if ((questionKey == 'AGE') || (singleQuestion.q_id == this.env.innovate.dobRedHerringQId && !trgAgeAns && isAGEExist)) {//checking Age Range if Age question is exist
                        let intAge = Number.parseInt(answer);
                        for (let i = 0, len = questionOptions.length; i < len; i++) {
                            if (Number.parseInt(questionOptions[i]['startAge']) <= intAge && Number.parseInt(questionOptions[i]['endAge']) >= intAge) {
                                isFallBetweenAge = 1;
                            }
                        }
                        if (!isFallBetweenAge) {
                            console.info("Age case terminate");
                            this.rootData.termReason = questionKey;
                            isTerminate = true;
                        }
                    } else if (questionKey == 'ZIPCODES') {
                        let isZipCodeExist = false;
                        if (questionOptions.length) {
                            for (let i = 0, len = questionOptions.length; i < len; i++) {
                                // for canada and United Kingdom if we upload 3 digit Code and panelist attend the question and add 6 digit postalcode at that time we are checking first 3 digit of postalCode and continue panelist in survey.
                                if (questionOptions[i]['opt_txt'].toUpperCase() === answer.toUpperCase()
                                    || (this.env.innovate.zipCntShortCode[countyCode]
                                        && questionOptions[i]['opt_txt'].substring(0, 3) === answer.substring(0, 3))) {
                                    isZipCodeExist = true;
                                }
                            }
                        } else {//ADMIN-2136 Need to capture zipcode question if not uploaded from targeting
                            isZipCodeExist = true;
                        }
                        if (!isZipCodeExist) {
                            console.info("Zipcode case terminate");
                            this.rootData.termReason = questionKey;
                            isTerminate = true;
                        }
                    } else if (questionKey == "DMA_CODE") {
                        if (!optionTxt.includes(answer.toString())) {
                            this.rootData.termReason = questionKey;
                            isTerminate = true;
                        }
                    } else if (trgAgeAns != null && singleQuestion.q_id == this.env.innovate.dobRedHerringQId && Number.parseInt(trgAgeAns) != Number.parseInt(answer)) {
                        this.rootData.termReason = singleQuestion.q_key;
                        isTerminate = true;
                    } else {
                        // in this case always proceed
                    }
                    break;
                case 'Open End-Text':
                    // in this case there is no requirement of matching, so it will always move further
                    break;
                case 'Single Punch':

                    // only single option have to be same
                    if ((this.env.innovate.cntShortCode[countyCode]) && (questionKey == "STATE" || questionKey == "REGION" || questionKey == "DMA_NAME")) {
                        if (answer.includes('(')) {//Here, we neglecting paranthesis text
                            answer = answer.split('(')[0].trim();
                        }
                        let answerRegex = new RegExp(["^", answer, "$"].join(""), 'i');
                        console.info('\nmatching regex-->', answerRegex + 'from questionOptions text');
                        let answerIndex = this.findAnswerIndex(optionTxt, answerRegex);

                        if (answerIndex == -1) {
                            this.rootData.termReason = questionKey;
                            isTerminate = true;
                        }
                    } else {
                        if (!optionIds.includes(answer.toString())) {
                            this.rootData.termReason = singleQuestion.q_key;
                            isTerminate = true;
                        }
                        if (singleQuestion.termOpts?.length) {
                            singleQuestion.termOpts.forEach((termOpt: any) => {
                                if (termOpt.opt_id == answer) {
                                    this.rootData.termReason = singleQuestion.q_key;
                                    isTerminate = true;
                                }
                            });
                        }
                    }
                    break;
                case 'Multipunch':
                    if (!this.anyMatchInOptions(answer, optionIds)) {
                        this.rootData.termReason = singleQuestion.q_key;
                        isTerminate = true;
                    }
                    if (answer.length > singleQuestion.termsCount) {
                        this.rootData.termReason = singleQuestion.q_key;
                        isTerminate = true;
                    }
                    if (singleQuestion?.termOpts?.length) {
                        singleQuestion.termOpts.forEach((termOpt: any) => {
                            if (answer.includes(termOpt.opt_id.toString())) {
                                this.rootData.termReason = singleQuestion.q_key;
                                isTerminate = true;
                            }
                        });
                    }
                    break;
                default:
            }
        }
        return isTerminate;
    }

    //Function to find index from array of answers
    findAnswerIndex(answerArr: any, answerIndex: any) {
        let index = -1;
        for (let i = 0; i < answerArr.length; ++i) {
            if (answerArr[i].match(answerIndex) != null) {
                index = i;
            }
        }
        return index;
    }

    anyMatchInOptions(answer: any, optionIds: any) {
        let found = false, i, j;
        for (i = 0, j = answer.length; !found && i < j; i++) {
            if (optionIds.includes(answer[i])) {
                found = true;
            }
        };
        return found;
    }

    public saveChoicesTemporarily(tempAnswer: any, keyForSaving: any, question_key: any, endTime: any, startTime: any, currentQuestion: any) {
        return new Promise((resolve, reject) => {
            let isQuestionExist = 0;
            let questionKeyIndex: any;
            let allAnswers: any = [];
            let savedData = [];
            let grpAnswer = {};
            let singleAnswer = {};
            if (tempAnswer.question_type == this.env.innovate.questionType["numericOpenEnded"] || tempAnswer.question_type == this.env.innovate.questionType["openEndedText"]) {
                tempAnswer['endTime'] = endTime;
                tempAnswer['startTime'] = startTime;
            }
            let currentQuesCatIdArray = currentQuestion.category.map((element: any) => { if (element.isPrimary) return element.id });
            tempAnswer['quesCatId'] = currentQuesCatIdArray[0]; //we are storing question cat in userpanlist collection in choices to reduce db call at BE
            if (this.env.innovate.enableOEVaildation && currentQuesCatIdArray &&
                (currentQuesCatIdArray[0] === this.env.innovate.dynamicProGPTCatId ||
                    (currentQuesCatIdArray[0] === this.env.innovate.qualitativeQuesCatId &&
                currentQuestion.automatedOEQues === 1)
            ) && !this.rootData.Test) { // ADMIN-4105 - In test URL case, removing the API call to rServer/TA
                    const obj: any = {
                        id : tempAnswer.question_id,
                        answer : tempAnswer.answer,
                        langCode : this.rootData.langCode,
                        timeDiff : (tempAnswer.endTime.getTime() - tempAnswer.startTime.getTime()) / 1000,
                        oeThreshLev : this.rootData.oeThreshLev,
                        isPega : this.rootData.isPega,
                        isOEValidation: this.rootData.isOEValidation,
                        taVersion: this.rootData.jobDetailsObj?.taVersion || 1, // default taVersion is 1(R + chatGPT)
                        cat: currentQuesCatIdArray[0],
                        jobId: this.rootData?.jobDetailsObj?.id ? this.rootData.jobDetailsObj.id : '',
                        token: this.rootData.token,
                        countryCode: this.rootData.countryCode,
                        customerId: this.rootData.jobDetailsObj?.cust?.cid ?? '',
                    };
                    this.http.post(this.baseURLV2+ '/userResponseValidate/OEResponse', obj).subscribe((response: any) => {
                        console.log('OEResponse response success'+this.rootData.token);
                        tempAnswer['terminate'] = response.data.terminate;
                        tempAnswer['rResponse'] = response.data.rResponse || {};
                        if(response.data.hasOwnProperty('chatGPTResponse')) {
                            tempAnswer['chatGPTResponse'] = response.data.chatGPTResponse;
                        }
                        if(response.data.hasOwnProperty('oldRServerResponse')) {
                            tempAnswer['oldRServerResponse'] = response.data.oldRServerResponse;
                        }
                        if(response.data.hasOwnProperty('hasRResponseManipulatedByGPT')) {
                            tempAnswer['hasRResponseManipulatedByGPT'] = response.data.hasRResponseManipulatedByGPT;
                        }
                        if(response.data.hasOwnProperty('isChatGPTEnabled')) {
                            tempAnswer['isChatGPTEnabled'] = response.data.isChatGPTEnabled;
                        }
                        if(response.data.hasOwnProperty('termReasonDetails')){
                            tempAnswer['termReasonDetails'] = response.data.termReasonDetails;
                        }
                        if(response.data.hasOwnProperty('detectedLanguageResponse')){
                            tempAnswer['detectedLanguageResponse'] = response.data.detectedLanguageResponse;
                        }
                        if(response.data.hasOwnProperty('isAnswerLangaugeCorrect')){
                            tempAnswer['isAnswerLangaugeCorrect'] = response.data.isAnswerLangaugeCorrect;
                        }
                        if(response.data.hasOwnProperty('isNewRServerResponse')) {
                            tempAnswer['isNewRServerResponse'] = response.data.isNewRServerResponse;
                        }
                        if(response.data.hasOwnProperty('rServerTermReason')){
                            tempAnswer['rServerTermReason'] = response.data.rServerTermReason;
                        }
                        if(response.data.hasOwnProperty('rResponseV2')){
                            tempAnswer['rResponseV2'] = response.data.rResponseV2;
                        }
                        this.saveTempChoice(keyForSaving, question_key, questionKeyIndex, isQuestionExist, tempAnswer, singleAnswer, allAnswers, grpAnswer);
                        resolve(null);
                    },(error: any) => {
                        resolve(null);
                    })
            } else {
                this.saveTempChoice(keyForSaving, question_key, questionKeyIndex, isQuestionExist, tempAnswer, singleAnswer, allAnswers, grpAnswer);
                resolve(null);
            }
        });
    }

    validateOE(rResponse: any, thresholds: any) {
        let terminate = false;
        if (rResponse.cp_score_2 < thresholds.copyPasteQues ||
            rResponse.cp_score_1 >= thresholds.wps ||
            rResponse.profanity_score > thresholds.profanity ||
            (thresholds.flagUrl && Number(rResponse.is_url)) || // if url is not allowed and OE has URL => terminate
            (rResponse.n_words == thresholds.nWords && rResponse.spelling >= thresholds.spellInt) ||
            (rResponse.n_words > thresholds.nWords && rResponse.spelling >= thresholds.spellFloat) ||
            (thresholds.flagPrevAnsMatch && !Number(rResponse.past_oe) && rResponse.n_words > thresholds.nWords) || // previous ans not allowed and OE contains prev answer, past_oe 0 for prev answer and n_words > nWords
            rResponse.contextuality < thresholds.contextuality ||
            (thresholds.flagTrmLstAnsMtch && Number(rResponse.term_flag))) {
            terminate = true;
        }
        return terminate;
    }

    saveTempChoice(keyForSaving: any, question_key: any, questionKeyIndex: number, isQuestionExist: number, tempAnswer: any, singleAnswer: any, allAnswers: any, grpAnswer: any) {
        let userSavedAnswers: any = this.getLocalStorage('localStorageSavedAnswers');
        if (userSavedAnswers && userSavedAnswers.length > 0) {
            userSavedAnswers.forEach((savedData: any, key: any) => {
                if (userSavedAnswers[key]?.[keyForSaving]) {
                    savedData = userSavedAnswers[key][keyForSaving];
                    savedData.forEach((singleData: any, question_index: any) => {
                        if (singleData[question_key]) {
                            questionKeyIndex = question_index;
                            isQuestionExist = 1;
                        }
                    });
                    if (isQuestionExist) {
                        savedData[questionKeyIndex][question_key] = tempAnswer;
                        userSavedAnswers[key][keyForSaving] = savedData;
                    } else {
                        singleAnswer[question_key] = tempAnswer;
                        savedData.push(singleAnswer);
                        userSavedAnswers[key][keyForSaving] = savedData;
                    }
                } else {
                    singleAnswer[question_key] = tempAnswer;
                    allAnswers.push(singleAnswer);
                    userSavedAnswers[key][keyForSaving] = allAnswers;
                }
            });
        } else {
            userSavedAnswers = [];
            singleAnswer[question_key] = tempAnswer;
            allAnswers.push(singleAnswer);
            grpAnswer[keyForSaving] = allAnswers;
            userSavedAnswers.push(grpAnswer);
        }
        this.setLocalStorage('localStorageSavedAnswers', userSavedAnswers);
    }

    getZipcodeData(data: any) {
        return this.http.post(this.baseURLV2 + '/survey/getZipMasterData', this.commonEncryptionMethod(data));
    }

    public checkZipcodeValidation(country: string, zipcode: string, token: string) {
        return this.http.get(this.baseURLV2 + `/userResponseValidate/checkZipcodeValidation/${country}/${zipcode}`, { params: { token }});
    }

    public getOeThresholdFromSupplier(body: any) {
        return this.http.post(`${this.base_url}/getSupplierOeThreshold`, body);
    }

    public getSuplierByCondition(supCode: any) {
        return this.http.get(`${this.base_url}/getSuplierByCondition/${supCode}`);
    }

    public getSupplierRedirectURL(token: any) {
        console.info('getSupplierRedirectURL token ====>', token);
        if(this.env.innovate.oldRouteEnable){
            return this.http.get(`${this.base_url}/getSupplierRedirectURL/${token}`);
        }
        return this.http.get(this.baseURLV2 + `/survey/getSupplierRedirectURL/${token}`);
    }

    public commonPCCondition() {
        return (!this.rootData.surveyFlowLogic
            || this.rootData.profilingJobs.includes(this.rootData.jb_id)
            || this.rootData.babyCenterProfileSurveyJobId === this.rootData.jb_id
            || this.rootData.isPCProfile);
    }

    public setLocalStorage(key: string, value: any) {
        try{
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(`[SharedService] setLocalStorage error ${JSON.stringify(error)} for key ${key} and value ${JSON.stringify(value)}`);
        }
    }

    public getLocalStorage(key: string) {
        const value = localStorage.getItem(key);
        if (!value) {
            return [];
        }
        try {
            const parsed = JSON.parse(value);
            return parsed ?? [];
        } catch (error) {
            console.error(`[SharedService] getLocalStorage parse error for key ${key}: ${JSON.stringify(error)}`);
            return [];
        }
    }

    /**
     * For call multiPunchCheckboxSubscribed of survey.component.ts from here which is observable
     */
    public doMultiPunchCheckbox(data: any) {
        this.multiPunchCheckboxSource.next(data);
    }

    public sendOtpForSMSVerification(data: any) {
        return this.http.post(this.baseURLV2 + '/userResponseValidate/sendOtpForSMSVerification', this.commonEncryptionMethod(data));
    }

    public verifyOtpForSMSVerification(data: any) {
        return this.http.post(this.baseURLV2 + '/userResponseValidate/verifyOtpForSMSVerification', this.commonEncryptionMethod(data));
    }

    /**
     * For call updateRootDataQuestionsSubscribed of app.component.ts from here which is observable
     */
    public updateRootDataQuestions(data: any) {
        this.updateRootDataQuestionsSource.next(data);
    }

    public getSurveyDetails(data: any) {
        return this.http.post(`${this.baseURLV2}/survey/getSurveyDetails`, this.commonEncryptionMethod(data));

    }

    public storeFirstQuestionDetails(data: any) {
        return this.http.post(`${this.baseURLV2}/survey/firstQuestionLoadDetails`, this.commonEncryptionMethod(data));

    }

    public rdActivityAPICall(url:any, option:any){
        return this.http.get(url, option);
    }
    public rdGetTokenAPI(url:any, option:any){
        return this.http.get(url, option);
    }
    public saveResearchDefenderResp (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveResearchDefenderResponse/', data);
    }
    public saveConsentDetails (data: any = {}, queryString:any) {
        return this.http.post(`${this.baseURLV2}/survey/saveConsentDetails/?`+queryString, data,{
            observe: "response"
        });
    }
    public saveCleanIdResponse (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveCleanIdResponse/', data);
    }
    public saveVeriSoulResponse (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveVeriSoulResponse/', data);
    }
    public commonEncryptionMethod(obj:any){
        return {
            data: CryptoJS.AES.encrypt(JSON.stringify(obj), this.env.innovate.secretKeyToEncDcryPayload).toString()
        }
    }
    public commonDecryptionMethod(obj: any) {
        if (!obj?.data) {
            console.error(`commonDecryptionMethod failed: missing encrypted data ${JSON.stringify(obj)}`);
            return null;
        }
        try {
            const decrypted = CryptoJS.AES.decrypt(obj.data, this.env.innovate.secretKeyToEncDcryPayload)
                .toString(CryptoJS.enc.Utf8);
            if (!decrypted) {
                console.error('commonDecryptionMethod failed: decryption produced empty string');
                return null;
            }
            return JSON.parse(decrypted);
        } catch (error) {
            console.error(`commonDecryptionMethod failed: ${JSON.stringify(error)}`);
            return null;
        }
    }
    public saveRFGFpAPICall (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveRFGResponse/', data);
    }

    public getAddressSuggestionsFromGogle(input: any, country: any) {
        const params = { input, country };
        return this.http.get(this.baseURLV2 + '/userResponseValidate/autoCompleteAddressByGoogle/', { params });
    }

    public getPlaceDetailsFromGoogle(placeId: any) { 
        const params = { placeId }; 
        return this.http.get(this.baseURLV2 + '/userResponseValidate/getPlaceDetailsFromGoogle/', { params });
    }

    public addressValidationByGoogle(addrsDetails: any, token: any) {
        const obj: any = {addrsDetails, token};
        return this.http.post(this.baseURLV2 + '/userResponseValidate/verifyAddressByGoogle/', obj);
    }
    
    public emailValidate (piiquestionDetails:any,jobId:any) {
        const obj: any = {piiquestionDetails, jobId};
        return this.http.post(this.baseURLV2 + '/userResponseValidate/verifyDuplicateEmail/', obj);
    }

    public saveCleanIdAndRDResponse(obj:any){
        return this.http.post(this.baseURLV2 + '/respondent/saveCleanIdAndRDResponse/', obj);
    }

    public saveSrvySatisfactionResponse(payload:any){
        return this.http.post(this.baseURLV2 + '/survey/saveSrvySatisfactionResponse/', payload);
    }

    public getSurveySatisfactionQuestion(token: any){
        return this.http.get(this.baseURLV2 + '/survey/getSurveySatisfactionQues/', { params: { token } });
    }

    public saveVeriSoulResponseParallel (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveVerisoulResponseInParallelFingerPrint/', data);
    }

    public saveCleanIdResponseParallel (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveCleanIdResponseInParallelFingerPrint/', data);
    }

    public saveRDActivityResponseParallel (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveRDActivityResponseInParallelFingerPrint/', data);
    }

    public getPersonilzedSurvey(uid: any){
        return this.http.get(this.baseURLV2 + '/survey/getPersonalizedSurvey/' + uid);
    }
    
    public noticeNewRelicError(context: string, err?: any, uid?: string): void {
        noticeNewRelicError(context, err, uid ?? this.rootData?.uid);
    }

    public saveDQCResponseInParallel (data: any = {}) {
        return this.http.post(this.baseURLV2 + '/respondent/saveDQCResponseInParallel/', data);
    }
    
}

/** For non-Angular modules (e.g. verisoul.service.js). */
export function noticeNewRelicError(context: string, err?: any, uid?: string): void {
    const nr = (window as any).newrelic;
    if (!nr?.noticeError) {
        return;
    }
    const error = err instanceof Error ? err : new Error(err?.message || context);
    const attributes: { context: string; uid?: string } = { context };
    if (uid) {
        attributes.uid = uid;
    }
    nr.noticeError(error, attributes);
}